import { Box, Button, FormControl, FormLabel, IconButton, Input, InputGroup, InputRightElement } from '@chakra-ui/react'
import { useFormik } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IoEye, IoEyeOff } from 'react-icons/io5'
import { logger } from 'src/shared/Logger'
import { useIamStore } from '../../apis/store'
import useLogIn from '../../hooks/useLogIn'
import LoginFormForgotPassword from '../LoginFormForgotPassword'
import LogInHeading from '../LogInHeading'

export const LOGIN_FORM_TEST_IDS = Object.freeze({
  email: 'login-form-input-email',
  password: 'login-form-input-pwd',
  button: 'login-form-btn',
})

const LoginForm: React.FC = () => {
  const [t] = useTranslation()
  const { setCredentials, isLoading } = useLogIn()
  const { userEmail, sendEvent } = useIamStore((state) => ({ userEmail: state.userEmail, sendEvent: state.sendEvent }))
  const [showPassword, setShowPassword] = React.useState(false)
  const form = useFormik({
    initialValues: {
      email: userEmail,
      password: '',
    },
    onSubmit: (values) => {
      logger.setUser({ email: values.email })
      setCredentials(values)
    },
  })
  return (
    <>
      <LogInHeading />
      <form onSubmit={form.handleSubmit}>
        <FormControl id='email' isInvalid={!!(form.errors.email && form.touched.email)}>
          <FormLabel
            htmlFor='email'
            fontFamily='Mulish'
            fontWeight='700'
            color='gray.800'
            fontSize='16px'
            marginBottom='2px'
          >
            {t('login.E-mail')}
          </FormLabel>
          <Input
            variant={userEmail ? 'filled' : 'loginInput'}
            disabled={userEmail ? true : false}
            type='email'
            data-testid={LOGIN_FORM_TEST_IDS.email}
            placeholder={t('login.Enter your e-mail')}
            borderRadius='16px'
            onChange={form.handleChange}
            value={form.values.email}
          />
        </FormControl>
        <FormControl id='password' isInvalid={!!(form.errors.password && form.touched.password)}>
          <FormLabel
            htmlFor='password'
            fontWeight='700'
            color='gray.800'
            fontSize='16px'
            variant='filled'
            marginTop='14px'
            marginBottom='2px'
          >
            {t('login.Password')}
          </FormLabel>
          <InputGroup>
            <Input
              variant='loginInput'
              type={showPassword ? 'text' : 'password'}
              autoComplete='current-password'
              id='current-password'
              name='password'
              placeholder={t('login.Enter your password')}
              w='100%'
              data-testid={LOGIN_FORM_TEST_IDS.password}
              borderRadius='16px'
              onChange={form.handleChange}
              value={form.values.password}
            />
            <InputRightElement width='4.5rem'>
              <IconButton
                as='div'
                cursor='pointer'
                icon={showPassword ? <IoEyeOff /> : <IoEye />}
                backgroundColor='transparent'
                _hover={{
                  bg: 'transparent',
                }}
                _active={{
                  bg: 'transparent',
                }}
                _focus={{
                  bg: 'transparent',
                }}
                fontSize='xl'
                color='gray.700'
                size='sm'
                fontFamily='Poppins'
                fontWeight='bold'
                aria-label='Show/hide password'
                onClick={() => setShowPassword((data) => !data)}
                type='button'
              ></IconButton>
            </InputRightElement>
          </InputGroup>
        </FormControl>
        <Box marginTop={{ base: '8px' }}>
          <LoginFormForgotPassword />
        </Box>
        <Button
          isLoading={isLoading}
          type='submit'
          data-testid={LOGIN_FORM_TEST_IDS.button}
          variant='loginDark'
          marginTop='31px'
        >
          {t('login.Login')}
        </Button>
        <Button
          onClick={() => sendEvent({ type: 'BACK' })}
          disabled={isLoading}
          variant={'outline'}
          data-testid={'btn-verify-login'}
          marginTop={{ base: '24px', lg: '31px' }}
          width={'100%'}
        >
          {t('login.Voltar')}
        </Button>
      </form>
    </>
  )
}

export default LoginForm
